<template>
  <div>
    <ViewTemplate :table-props="mappingColumns" :project-param-id="projectParamId" :mapper-param-id="mapperParamId" />
  </div>
</template>

<script>
import { pageViews, type } from "../utils/util";
import Store from "../vuex/store.js";
import TabContentView from "./TabContentView.vue";
import ViewTemplate from "@/components/ViewTemplate.vue";

export default {
  name: pageViews.MAPPING_REFERENCES_VIEW,
  methods: {
    setValuesToStore(type) {
      Store.commit("setType", type);
    }
  },
  mounted() {
    this.setValuesToStore(type.MAPPER_MAPPING_REFERENCES);
    console.log("MappingReferencesView mounted");
  },
  components: {
    TabContentView,
    ViewTemplate
  },
  data() {
    return {
      uploadConfigs: {
        action: "generator",
        actionLabel: "Generator",
        title: "Mapper Config Generator",
        type: type.MAPPER_MAPPING_REFERENCES,
        accept: ".zip",
      },
      mappingColumns: {
        type: type.MAPPER_MAPPING_REFERENCES,
        isMultiSelectionAllowed: true,
        defaultSortOrder: { name: "asc", label: "Ascending" },
        defaultSortColumn: { name: "Process", label: "Process" },
        configs: [
          { name: "usecaseLocation", label: "Use Case Location", order: 1, isSortable: true, defaultSelected: false, textAlign: "left" },
          { name: "usecase", label: "Use Case", order: 2, isSortable: true, defaultSelected: true, textAlign: "left" },
          { name: "processLocation", label: "Process Location", order: 3, isSortable: true, defaultSelected: false, textAlign: "left" },
          { name: "process", label: "Process", order: 4, isSortable: true, defaultSelected: true, textAlign: "left" },
          { name: "activity", label: "Activity Name", order: 5, isSortable: true, defaultSelected: true, textAlign: "left" },
          { name: "activityType", label: "Activity Type", order: 6, isSortable: true, defaultSelected: true, textAlign: "left" },
          { name: "fieldName", label: "Field Name", order: 7, isSortable: true, defaultSelected: true, textAlign: "left" },
          { name: "refType", label: "Reference type", order: 8, isSortable: true, defaultSelected: true, textAlign: "left" },
          { name: "referenceName", label: "Reference Name", order: 9, isSortable: true, defaultSelected: true, textAlign: "left" },  
          { name: "referenceFieldName", label: "Reference Field Name", order: 10, isSortable: true, defaultSelected: true, textAlign: "left" },  
          { name: "expression", label: "Expression", order: 11, isSortable: true, defaultSelected: true, textAlign: "left" },                  
        ],
        actions: {
          viewPopup: { label: 'View Output' },
          download: { label: 'Request Download' },
          calculate: { label: 'Calculate Complexity' },
        },
      },
    };
  },
  props: ["projectParamId", "mapperParamId"],
};
</script>
